// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1100983e","453":"d5a1c2c8","455":"135ec3cb"}[chunkId] + ".chunk.js";
};